import { preferenceFactory } from './preference-middleware';
import { campaignPreferenceFactory } from './campaign-preference-middleware';

export const middlewares = {
  preferenceFactory,
  campaignPreferenceFactory,
};
